import http from "infra/http";
import { useQuery } from "react-query";
import { ParametrosCobrancaTransferenciaResponse } from "../typings";

function useParametrosCobrancaTransferencia(tenant?: string) {
  const url = `v1/parametros-cobranca/${tenant}/transferencia`;
  return useQuery(
    url,
    async () => {
      const { data } = await http.get<ParametrosCobrancaTransferenciaResponse>(url);
      return data;
    },
    {
      enabled: !!tenant,
    }
  );
}

export default useParametrosCobrancaTransferencia;
